module.exports = __webpack_public_path__ + "static/media/premiumOverlay.eb7f6588.svg";